import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/main",
      name: "main",
      component: () => import("../components/main"),
      children: [
        {
          path: "/",
          component: () => import("../views/home")
        },
        {
          path: "/print",
          component: () => import("../views/print")
        },
        {
          path: "/scan",
          component: () => import("../views/scan")
        },
        {
          path: "/wallet",
          component: () => import("../views/wallet/index")
        }, ,
        {
          path: "/wallet-log",
          component: () => import("../views/wallet-log/index")
        },
        {
          path: "/staff",
          component: () => import("../views/wallet/staff")
        },
        {
          path: "/consumption",
          component: () => import("../views/consumption")
        },
        {
          path: "/message",
          component: () => import("../views/message")
        },
        {
          path: "/info/:mode",
          name: "info",
          component: () => import("../views/info/index")
        }
      ]
    },
    {
      path: "/code-login",
      name: "login",
      component: () => import("../views/user/index")
    },
    {
      path: "/",
      name: "pass-login",
      component: () => import("../views/user/password-login")
    },
    {
      path: "/pass-reteieve",
      name: "pass-reteieve",
      component: () => import("../views/user/password-retrieve")
    },
    {
      path: "/pass-reset",
      name: "pass-reset",
      component: () => import("../views/user/password-reset")
    },
    {
      path: "/pass-set",
      name: "pass-set",
      component: () => import("../views/user/password-set")
    },
    {
      path: "/login/wechat",
      name: "login-wechat",
      component: () => import("../views/user/login-wechat")
    },
    {
      path: "/login/dingtalk",
      name: "login-dingtalk",
      component: () => import("../views/user/login-dingtalk")
    }
  ]
});
